module.exports = __webpack_public_path__ + "static/media/calendario.bac19fd7.pdf";